module.exports = __webpack_public_path__ + "media/bootstrap-icons/distribute-horizontal-c4a7c4bc.svg";